<template>
  <IModal ref="modal" :with-close-button="false" :with-action-button="false" :is-loading="true" :close-on-click-modal="false">
    <div :class="$style.content">
      <SvgIcon :svg="LoaderSvg" width="32" data-chromatic="ignore" />
      <p v-if="loadingText" :class="$style.loadingText">{{ loadingText }}</p>
    </div>
  </IModal>
</template>

<script setup lang="ts">
import IModal from '@/js/components/molecules/IModal.vue';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import LoaderSvg from '@/svgs/vue/loader.svg';

withDefaults(
  defineProps<{
    loadingText?: string;
  }>(),
  {
    loadingText: '',
  },
);
</script>

<style module lang="scss">
.content {
  text-align: center;
}

.loadingText {
  margin: 0;
  padding-top: 8px;
}
</style>
